var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/experiments/grow3505/Grow3505EnterpriseItem.tsx",
  _this = this;
// GROW-3505: Add new workgroups card in submenu under Enterprise
// This is a new file copied from MenuItems component, but with
// the only difference of including a sub-card component for workgroups
import React, { useContext } from 'react';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { Link } from '@wds/link';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute } from '@sm/metrics';
import { IconWorkgroup } from '@wds/icons';
import { SubMenuItem } from '../../mobile-nav/SubMenuItem';
import useStyles from './useStyles';
import HeaderContext from '../../../HeaderContext';

// US-only experiment, no translations needed
var COPY = {
  WORKGROUPS_HEADER: 'Create groups of collaborators',
  WORKGROUPS_BLURB: 'Add collaborators and easily manage their access to many surveys at once. ',
  WORKGROUPS_DEMO: 'Get a demo'
};
var ENTERPRISE_URL = '/mp/ipas-contact-sales/?program=701PZ000008DbAHYA0';
var Grow3505EnterpriseItem = function Grow3505EnterpriseItem(_ref) {
  var title = _ref.title,
    url = _ref.url,
    subTitle = _ref.subTitle,
    navItem = _ref.navItem,
    _ref$openInNewWindow = _ref.openInNewWindow,
    openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow;
  var classes = useStyles();
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var metrics = generateMetricsAttribute({
    data: {
      url: pageURL,
      pageName: pageName,
      amplitudeEvent: 'header clicked navigation',
      navItem: navItem
    }
  });
  var workgroupsMetrics = generateMetricsAttribute({
    data: {
      pageName: pageName,
      amplitudeEvent: 'experiment event',
      eventName: 'header clicked workgroups'
    }
  });
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List.Item, Object.assign({
      interactive: true,
      isNavigable: true,
      href: url,
      "data-sm-metrics": metrics
    }, openInNewWindow === true && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Box, {
      py: 4,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 17
      }
    }, title), /*#__PURE__*/React.createElement(Box, {
      pt: 1,
      display: "flex",
      className: classes.descriptionBox,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 77,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 19
      }
    }, subTitle)))), /*#__PURE__*/React.createElement(Box, {
      pt: 1,
      display: "flex",
      flexDirection: "column",
      className: classes.grow3505Workgroups,
      "data-sm-metrics": workgroupsMetrics,
      onClick: function onClick() {
        window.open(ENTERPRISE_URL, '_blank');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      className: classes.grow3505WorkgroupBlurb,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(IconWorkgroup, {
      title: "workgroup icon",
      color: "dark",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 95,
        columnNumber: 17
      }
    }, COPY.WORKGROUPS_HEADER)), /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      color: "darkMuted",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 15
      }
    }, COPY.WORKGROUPS_BLURB, /*#__PURE__*/React.createElement(Link, {
      href: ENTERPRISE_URL,
      target: "_blank",
      underline: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 101,
        columnNumber: 17
      }
    }, COPY.WORKGROUPS_DEMO)))) : /*#__PURE__*/React.createElement(SubMenuItem, {
      title: title,
      url: url,
      metrics: metrics,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 108,
        columnNumber: 11
      }
    });
  });
};
export default Grow3505EnterpriseItem;
export { Grow3505EnterpriseItem };
//# sourceMappingURL=Grow3505EnterpriseItem.js.map